import React, { useState, useRef, useEffect } from "react";
import MicroModal from "micromodal";
import { CloseCircle, Eye, EyeSlash } from "iconsax-reactjs";

import Typography from "../Typography";
import InputSearch from "../InputSearch/InputSearch";

import "./columns-filters.css";

import { ReactComponent as DragIcon } from "../../build/images/drag-icon.svg";

const ColumnsFilter = ({ columns, setColumns, modalId = "modal-columns" }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [blinkingIds, setBlinkingIds] = useState([]);
  const itemRefs = useRef({});
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  useEffect(() => {
    MicroModal.init({
      awaitCloseAnimation: true, // Permite que a animação de saída termine antes de remover do DOM
      disableScroll: false, // Impede o scroll da página de fundo quando o modal tá aberto
    });
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const lowerSearch = searchTerm.toLowerCase();
      const matches = columns.filter((col) =>
        col.Header.toLowerCase().includes(lowerSearch),
      );

      if (matches.length > 0) {
        const firstMatchId = matches[0].id;
        if (itemRefs.current[firstMatchId]) {
          itemRefs.current[firstMatchId].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }

        const matchIds = matches.map((m) => m.id);
        setBlinkingIds(matchIds);

        setTimeout(() => {
          setBlinkingIds([]);
        }, 1000);
      }
    }
  };

  const toggleVisibility = (id) => {
    const updatedColumns = columns.map((col) => {
      if (col.id === id) {
        return { ...col, display: !col.display };
      }
      return col;
    });
    setColumns(updatedColumns);
  };

  const handleDragStart = (index) => {
    dragItem.current = index;
  };

  const handleDragEnter = (index) => {
    dragOverItem.current = index;
  };

  const handleDragEnd = () => {
    if (
      dragItem.current !== null &&
      dragOverItem.current !== null &&
      dragItem.current !== dragOverItem.current
    ) {
      const newColumns = [...columns];
      const draggedItemContent = newColumns[dragItem.current];

      newColumns.splice(dragItem.current, 1);
      newColumns.splice(dragOverItem.current, 0, draggedItemContent);

      setColumns(newColumns);
    }
    dragItem.current = null;
    dragOverItem.current = null;
  };

  return (
    <div className="modal micromodal-slide" id={modalId} aria-hidden="true">
      <div className="modal__overlay" tabIndex="-1" data-micromodal-close>
        <div
          className="modal__container cf-container"
          role="dialog"
          aria-modal="true"
          aria-labelledby={`${modalId}-title`}
        >
          <div className="cf-header">
            <Typography.H4
              color={"gray-600"}
              weight={700}
              id={`${modalId}-title`}
            >
              Colunas
            </Typography.H4>
            {/* <h2 id={`${modalId}-title`}>Colunas</h2> */}
            <button
              className="cf-close-btn"
              aria-label="Fechar modal"
              data-micromodal-close
            >
              <CloseCircle
                variant="Outline"
                style={{ pointerEvents: "none" }}
              />
            </button>
          </div>

          <main className="cf-content" id={`${modalId}-content`}>
            <InputSearch
              exibIcon
              search={searchTerm}
              setSearch={setSearchTerm}
              onKeyDown
              onSearch={handleKeyDown}
            />

            <div className="cf-list">
              {columns.map((col, index) => {
                const isHidden = !col.display;
                const isBlinking = blinkingIds.includes(col.id);

                return (
                  <div
                    key={col.id}
                    ref={(el) => (itemRefs.current[col.id] = el)}
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragEnter={() => handleDragEnter(index)}
                    onDragEnd={handleDragEnd}
                    onDragOver={(e) => e.preventDefault()}
                    className={`cf-item ${isHidden ? "cf-item-hidden" : "cf-item-visible"} ${isBlinking ? "cf-blink" : ""}`}
                  >
                    <div className="cf-item-left">
                      <div className="cf-drag-handle">
                        <DragIcon
                          className={isHidden ? "icon-blue" : "icon-gray"}
                        />
                      </div>
                      {/* <span className="cf-item-title"> */}
                      <Typography.H5
                        weight={500}
                        color={isHidden ? "primary-light" : "gray-400"}
                      >
                        {col.Header}
                      </Typography.H5>
                      {/* </span> */}
                    </div>

                    <div className="cf-item-right">
                      <button
                        className="cf-eye-btn"
                        onClick={() => toggleVisibility(col.id)}
                        title={isHidden ? "Mostrar coluna" : "Ocultar coluna"}
                      >
                        {isHidden ? (
                          <EyeSlash variant="Outline" />
                        ) : (
                          <Eye variant="Outline" />
                        )}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ColumnsFilter;
